import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { PageLayout } from "lib";
import { useHistory } from "react-router-dom";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { useUser } from "hooks/useUser";
import styles from "./ReportsHub.module.scss";

const reportCategories = [
  {
    id: "event-checkin",
    title: "Check-in Evenimente",
    description: "Analiză flux check-in, bilete scanate, timing și statistici per eveniment",
    icon: EventIcon,
    path: "/reports/event-checkin",
    available: true,
    color: "#667eea",
  },
];

const ReportsHub = () => {
  const history = useHistory();
  const { permissionsData } = useUser();

  // Redirect non-admin users to home
  useEffect(() => {
    if (!permissionsData.seeAdminButtons) {
      history.push("/");
    }
  }, [permissionsData.seeAdminButtons, history]);

  const handleCardClick = (report) => {
    if (report.available) {
      history.push(report.path);
    }
  };

  return (
    <>
      <Helmet>
        <title>InBusiness CRM :: Rapoarte</title>
      </Helmet>
      <PageLayout title="Centru Rapoarte">
        <div className={styles.container}>
          <Typography variant="body1" className={styles.subtitle}>
            Selectează tipul de raport pe care dorești să-l vizualizezi
          </Typography>

          <Grid container spacing={3} className={styles.cardsGrid}>
            {reportCategories.map((report) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={report.id}>
                <Card
                  className={`${styles.reportCard} ${
                    !report.available ? styles.disabled : ""
                  }`}
                  onClick={() => handleCardClick(report)}
                  style={{
                    "--card-color": report.color,
                  }}
                >
                  <CardContent className={styles.cardContent}>
                    <div
                      className={styles.iconWrapper}
                      style={{ backgroundColor: report.color }}
                    >
                      <report.icon className={styles.icon} />
                    </div>
                    <Typography variant="h6" className={styles.cardTitle}>
                      {report.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      className={styles.cardDescription}
                    >
                      {report.description}
                    </Typography>
                    {!report.available && (
                      <span className={styles.comingSoon}>În curând</span>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </div>
      </PageLayout>
    </>
  );
};

export default ReportsHub;
